import React, { useEffect, useState } from 'react';
import s from './PublishedPostPage.module.css';
import { useSelector } from 'react-redux';
import {
    selectScriptData,
    selectImageData,
    selectPostSuccess,
} from '../../../store/selectors/projectSelectors';
import { useFetchProject } from '../../../shared/hooks/useFetchProject';
import { useParams, useNavigate } from 'react-router-dom';
import LogoComponent from '../../../shared/ui/logo/LogoComponent';
import Button from '../../../shared/ui/button/Button';
import IconEdit from '../../../shared/ui/icons/IconEdit';
import IconCalendar from '../../../shared/ui/icons/IconCalendar';
import IconDashboard from '../../../shared/ui/icons/IconDashboard';
import IconStars from '../../../shared/ui/icons/IconStars';
import IconRocket from '../../../shared/ui/icons/IconRocket';
import InstagramPost from '../../../shared/ui/instagram-post/InstagramPost';
import { PostModal } from '../../../shared/ui/post-modal/PostModal';
import { selectUser } from '../../../store/selectors/authSelectors';
import {
    selectIsBasicSubscription,
    selectIsFreeSubscription,
} from '../../../store/selectors/subscriptionSelector';
import { useTheme } from '../../../shared/context/ThemeContext';

const PublishedPostPage = () => {
    useFetchProject();
    const [showPostModal, setShowPostModal] = useState(false);
    const scriptData = useSelector(selectScriptData);
    const imageData = useSelector(selectImageData);
    const { projectId } = useParams();
    const navigate = useNavigate();
    const user = useSelector(selectUser);
    const { isDarkTheme } = useTheme();

    const isFreeSubscription = useSelector(selectIsFreeSubscription);
    const isBasicSubscription = useSelector(selectIsBasicSubscription);

    console.log(scriptData, 'scriptData');

    return (
        <div className={s.container}>
            <LogoComponent />
            <div className={s.post_container_wrapper}>
                <div className={s.post_container}>
                    <h2 className={s.post_header}>You just launched. Let’s keep the momentum!</h2>

                    <p className={s.post_text}>🎉 First post milestone unlocked!</p>

                    <div className={s.button_container}>
                        <Button
                            text="Edit Post"
                            onClick={() => {
                                navigate(`/custom-post/${projectId}`);
                            }}
                            style={{
                                backgroundColor: 'var(--background)',
                                border: '1px solid var(--outline-color)',
                                color: 'var(--primary-color)',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={<IconEdit color={isDarkTheme ? '#fff' : '#000'} />}
                        />

                        <Button
                            text="Let’s go to my dashboard"
                            onClick={() => {
                                navigate(`/dashboard`);
                            }}
                            style={{
                                backgroundColor: 'var(--background)',
                                border: '1px solid var(--outline-color)',
                                color: 'var(--primary-color)',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={<IconDashboard color={isDarkTheme ? '#fff' : '#000'} />}
                        />

                        <Button
                            text="Generate 3 more like this"
                            onClick={() => {
                                navigate(`/multiple-posts/${projectId}`);
                            }}
                            style={{
                                background: 'linear-gradient(90deg, #8801FF 0%, #D400FF 100%)',
                                color: '#fff',
                                height: '45px',
                            }}
                            iconPosition="left"
                            icon={<IconStars color="white" />}
                        />

                        <Button
                            text={
                                isFreeSubscription || isBasicSubscription
                                    ? 'Get premium'
                                    : 'Get Pro'
                            }
                            onClick={() => navigate('/pricing')}
                            style={{ backgroundColor: '#FFDD35', height: '45px' }}
                            iconPosition="left"
                            icon={<IconRocket />}
                        />
                    </div>

                    <p className={s.post_text}>
                        Unlock in Premium plan to post on other platforms right away!
                    </p>
                </div>
                <InstagramPost
                    avatar={user?.profile_picture || null}
                    name={'Mariia'}
                    text={scriptData}
                    image={imageData}
                    isPosted={true}
                />
            </div>
            <PostModal isOpen={showPostModal} onClose={() => setShowPostModal(false)} />
        </div>
    );
};

export default PublishedPostPage;
